import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "i18n-fe";

// #3479 - the plain-words block of a Review Queue row: ONE line (item.summary,
// written by score-api's REASON_CATALOG, naming the ride, rider and judge the
// kind has) and a "More" link that opens why it matters, what each button does
// and what changes. The wording is the server's, like the buttons, so a kind
// this build has never seen still reads plainly. `fallback` is the older
// per-kind text for an item from a server that predates summary/more.
export default function ReviewItemSummary({ item, fallback }) {
  const { t } = useTranslation("scoreadmin");
  const [open, setOpen] = useState(false);
  const more = item.more;
  const line = item.summary || fallback || item.decision;
  return (
    <Box data-testid="review-item-summary-block">
      <Typography variant="body2" color="text.primary" data-testid="review-item-summary">
        {line}
      </Typography>
      {more && (
        <>
          <Button
            size="small"
            sx={{ px: 0, minWidth: 0 }}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            data-testid="review-item-more-toggle"
          >
            {t(open ? "reviewQueue.more.less" : "reviewQueue.more.more")}
          </Button>
          {open && (
            <Box sx={{ mt: 0.5 }} data-testid="review-item-more">
              <Typography variant="body2" color="text.primary" sx={{ mb: 0.5 }} data-testid="review-item-more-why">
                {more.why}
              </Typography>
              {(more.buttons || []).map((button) => (
                <Typography key={button.label} variant="body2" color="text.primary" data-testid="review-item-more-button">
                  <strong>{button.label}:</strong> {button.text}
                </Typography>
              ))}
              <Typography variant="body2" color="text.primary" sx={{ mt: 0.5 }} data-testid="review-item-more-changes">
                {more.changes}
              </Typography>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}
